module.exports = __webpack_public_path__ + "static/media/DeviceList.35fb9adf.png";